import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ChatAlertIcon, Chip, FormatDate, Text } from '@reveni-io/reveni-ui'

import ClaimStatusChip from '@/parcels/components/ClaimStatusChip/ClaimStatusChip'

import { claimTypeChip } from '../constants'
import * as Styles from './styles'

const ClaimItem = ({ id, type, status, message, openedAt }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const typeChip = claimTypeChip?.[type]

  return (
    <Styles.Container>
      <Styles.HeaderRow>
        <Styles.HeaderLeft>
          <ChatAlertIcon size="24" />
          <Text type="titleM">{`#${id}`}</Text>
        </Styles.HeaderLeft>
        {openedAt && (
          <Text type="allCapsS" color={theme.colors.text.muted}>
            <FormatDate year="numeric" month="short" day="2-digit">
              {openedAt}
            </FormatDate>
          </Text>
        )}
      </Styles.HeaderRow>
      <Styles.ChipsRow>
        {typeChip && (
          <Chip
            label={<Text type="bodySMedium">{t(typeChip.label)}</Text>}
            backgroundColor={theme.colors.disabled.surface}
          />
        )}
        <ClaimStatusChip status={status} />
      </Styles.ChipsRow>
      {message && (
        <Text type="bodyMRegular" color={theme.colors.text.muted}>
          {message}
        </Text>
      )}
    </Styles.Container>
  )
}

export default ClaimItem
